import { render, staticRenderFns } from "./PwaAppr.vue?vue&type=template&id=b3572f66&"
import script from "./PwaAppr.vue?vue&type=script&lang=js&"
export * from "./PwaAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports